<template>
  <div class="latest-wrapper">
    <!-- <div class="tour-bckgnd grid-100 grid-parent"></div> -->
   <h1 class="main-title individual grid-container">Latest</h1>
   <div class="mobile-navigation latest layer3"></div>
   <div class="social-latest grid-100 grid-parent layer2">
    <div class="grid-container">
      <div class="grid-100">
        <div class="fb-box odd grid-48">
          <a target="_blank" href="https://www.facebook.com/Ross.Noble/"><h4>Ross.Noble</h4></a>
          <p v-html="fbPosts[0].message" class="fb-post-paragraph"></p>
          <span class="date">{{fbPosts[0].date}}</span>
          <div class="social-icon"> <a target="_blank" href="https://www.facebook.com/Ross.Noble/"><img src='../assets/images/facebook_white.png'></img></a></div>
        </div>
        <div class="tw-box even grid-24 margin-left-2">
          <a v-if="twPosts[0]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[0].id_str"><h4>@Realrossnoble</h4></a>
          <p v-html="twPosts[0].text" class="tw-post-paragraph"></p>
          <span class="date">{{getDateInFormatTW(twPosts[0].created_at)}}</span>
          <div class="social-icon"> <a v-if="twPosts[0]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[0].id_str"><img src='../assets/images/twitter.png'></img></a></div>
        </div>
        <div class="tw-box odd grid-24 margin-left-2">
          <a v-if="twPosts[1]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[1].id_str"><h4>@Realrossnoble</h4></a>
          <p v-html="twPosts[1].text" class="tw-post-paragraph"></p>
          <span class="date">{{getDateInFormatTW(twPosts[1].created_at)}}</span>
          <div class="social-icon"> <a v-if="twPosts[1]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[1].id_str"><img src='../assets/images/twitter_white.png'></img></a></div>
        </div>
        <div class="tw-box even grid-24">
          <a v-if="twPosts[2]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[2].id_str"><h4>@Realrossnoble</h4></a>
          <p v-html="twPosts[2].text" class="tw-post-paragraph"></p>
          <span class="date">{{getDateInFormatTW(twPosts[2].created_at)}}</span>
          <div class="social-icon"> <a v-if="twPosts[2]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[2].id_str"><img src='../assets/images/twitter.png'></img></a></div>
        </div>
         <div class="fb-box odd grid-48  margin-left-2">
          <a target="_blank" href="https://www.facebook.com/Ross.Noble/"><h4>Ross.Noble</h4></a>
          <p v-html="fbPosts[2].message" class="fb-post-paragraph"></p>
          <span class="date">{{fbPosts[1].date}}</span>
          <div class="social-icon"> <a target="_blank" href="https://www.facebook.com/Ross.Noble/"><img src='../assets/images/facebook_white.png'></img></a></div>
        </div>
        <div class="tw-box even grid-24 margin-left-2">
          <a v-if="twPosts[3]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[3].id_str"><h4>@Realrossnoble</h4></a>
          <p v-html="twPosts[3].text" class="post-paragraph"></p>
          <span class="date">{{getDateInFormatTW(twPosts[3].created_at)}}</span>
          <div class="social-icon"> <a v-if="twPosts[3]" target="_blank" v-bind:href="'https://twitter.com/realrossnoble/status/'+ twPosts[3].id_str"><img src='../assets/images/twitter.png'></img></a></div>
        </div>
      </div>
  </div>
  </div>

   <div v-if="itemData.id" class="overlay-grid grid-100 grid-parent">
    <div class="social-latest grid-100 grid-parent">
      <div class="grid-container">
        <div class="grid-100 grid-parent archive-list">
          <div class="grid-32 archive-item grid-parent"> 
            <div class="grid-100 grid-parent archive-content">
              <h1 v-html="itemData.title.rendered"></h1>
              <p v-html="itemData.content.rendered"></p> 
              <div class="archive-bottom grid-100 grid-parent mobile-grid-100">
                <span class="archive-date">{{getDateInFormat(itemData.date)}}</span> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
    <a class="close-archive" v-on:click="closeOverlay()"> <img src="../assets/images/close.png" /></a>
  </div> 


  <h1 class="main-title individual grid-container">Archive</h1>
  <div class="mobile-navigation latest layer3"></div>
   <div class="social-latest grid-100 grid-parent layer2">
    <div class="grid-container">
      <div class="grid-100 grid-parent archive-list">
        <div v-for="(item, $index) in result" class="grid-32 archive-item grid-parent" v-if="$index < 6" :class="{'odd': $index % 2 === 0, 'even': $index % 2 !== 0 }"> 
          <!-- <img class="archive-img" src="../assets/images/archive-img.png" /> -->
          <div class="grid-100 grid-parent archive-content">
            <h1 v-html="item.title.rendered"></h1>
            <!-- <p v-html="item.content.rendered"></p> -->
            <div class="archive-bottom grid-100 grid-parent mobile-grid-100">
               <span class="archive-date">{{getDateInFormat(item.date)}}</span> 
              <a v-on:click="showArchive(item.id)" class="archive-cta">MORE</a>
            </div>
          </div>
        </div>
      </div>
        <div class="grid-100 grid-parent">
          <div class="see-all-post" v-show="olderPostsHidden"  v-on:click="showOlderPosts()">
            <span>See older posts</span>
            <img src="../assets/images/arrow-down.svg" />
          </div> 
        </div>

      <div class="grid-100 grid-parent archive-list"  v-show="!olderPostsHidden">
        <div v-for="(item, $index) in result" class="grid-32 archive-item grid-parent" v-if="$index > 6" :class="{'odd': $index % 2 === 0, 'even': $index % 2 !== 0 }"> 
          <!-- <img class="archive-img" src="../assets/images/archive-img.png" /> -->
          <div class="grid-100 grid-parent archive-content">
            <h1 v-html="item.title.rendered"></h1>
            <!-- <p v-html="item.content.rendered"></p> -->
            <div class="archive-bottom grid-100 grid-parent mobile-grid-100">
               <span class="archive-date">{{getDateInFormat(item.date)}}</span> 
              <a v-on:click="showArchive(item.id)" class="archive-cta">MORE</a>
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>


  </div>
</template>

<script>
import axios from 'axios'
import { API_BASE } from '@/config';
import clamp from '@helpers/clamp';

export default {
  name: 'test',
  data () {
    return {
      result: [],
      itemData: [],
      olderPostsHidden: true,
      fbPosts: [{}, {}, {}],
      twPosts: []
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    
    setTimeout(function() {
      // console.log('clamp', clamp)
      // let paragraph = document.getElementsByClassName('post-paragraph');
      // clamp(paragraph[0], {clamp: 6, useNativeClamp: false, truncationChar: ' ', truncationHTML: '<a>...SEE MORE</a>'});
    }, 1000)
   // let paragraph = document.getElementsByClassName('post-paragraph')[0];
    // clamp(paragraph, {clamp: 1, useNativeClamp: false});
    // let consumerKey = 'MGUzBiXPXJcnJrtMyGdCttQTK'
    // // let consumer_secret = 'mMDeeCqSHRqTmlMWZVmgQXEL7Am9pcxHEPKf6IYL9glH0RYNx9'
    // let oauthToken = '85363141-1QXzGJNxwxttdoJfkiz6ztjptLYeNGZdKluEHOrAP'
    // let oauthTokenSecret = '1lkOWKrBs8I0FXxMIZxCjbpgxAO7qdVeLDPeThXf0TOp4'
    // let url = 'https://api.twitter.com/oauth/request_token?' + 'oauth_token=' + oauthToken + '&oauth_token_secret=' + oauthTokenSecret + '&user_id=85363141&screen_name=twitterapi'

    // axios({
    //   method: 'post',
    //   url: url,
    //   responseType: {'oauth_consumer_key': consumerKey}
    // })
    // .then(response => {
    //   console.log('TWITTER DATA', response.data)
    // })

    axios.get(`${API_BASE}/wp/wp-json/wp/v2/archive?per_page=100`,{
		mode: 'no-cors',
	})
    .then(response => { this.result = response.data })
    // var pageAccessToken = '495265850852276|SDLVC2YS92S7lcqVupbxpc12_Jc'
  /*   axios.get(`${API_BASE}/twitter.php`)
    .then(response => {
      this.twPosts = response.data
      console.log('this.twPosts', this.twPosts);
    }) */
    let vm = this
    setTimeout(function () {
      vm.getSocialMedia()
    }, 100)
  },
  methods: {
    showArchive (id) {
      axios.get(`${API_BASE}/wp/wp-json/wp/v2/archive/${id}`,  {
		mode: 'no-cors',
	})
      .then(response => {
        this.itemData = response.data
      })
    },
    showOlderPosts () {
      this.olderPostsHidden = false
    },
    closeOverlay () {
      this.itemData = []
    },
    getDateInFormat (date) {
      var d = new Date(date)
      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      var dayFormat
      switch (d.getDate()) {
        case 1:
          dayFormat = 'st'
          break
        case 2:
          dayFormat = 'nd'
          break
        case 3:
          dayFormat = 'rd'
          break
        default:
          dayFormat = 'th'
          break
      }
      return d.getDate() + dayFormat + ' ' + monthNames[d.getMonth()] + ' ' + d.getFullYear()
    },
    getDateInFormatTW (tWDate) {
      let twDateArray = tWDate.split(" ");
      return twDateArray[2] + ' ' + twDateArray[1] + ' ' + twDateArray[5]
    },
    getSocialMedia () {
      var pageAccessToken = '379705689194861|sfetwD4rHTyfmLeDGmXC4r3ZoHc'
      let vm = this
      setTimeout(function () {
        window.FB.api('/Ross.Noble/feed', {
          access_token: pageAccessToken,
          limit: 10
        },
        function (response) {
          let postsArray = []
          for (var i = 0; i < response.data.length; i++) {
            var item = {}
            item.message = response.data[i].message
            item.date = vm.getDateInFormat(response.data[i].created_time.substring(0, 10))
            postsArray.push(item)
          }
          // console.log('postsArray', postsArray)
          vm.fbPosts = postsArray
          setTimeout(function() {
            for (var i = 0; i < 6; i++) {
              let paragraph = document.getElementsByClassName('fb-post-paragraph');
              clamp(paragraph[i], {clamp: 6, useNativeClamp: false, truncationChar: ' ', truncationHTML: `<a class='see-more' href="https://www.facebook.com/Ross.Noble/" target='_blank'>...SEE MORE</a>`});
            }
          }, 10)
          // console.log('response--', vm.fbPosts, vm.fbPosts.length)
          // for (var i = 0; i < vm.fbPosts.length; i++) {
          //   console.log('-->In')
          //   var item = {}
          //   item.cat = 'tw'
          //   item.link = 'https://twitter.com/realrossnoble/status/903196606710894592'
          //   item.content = 'Blown away by the response to Young Frankenstein. still a few tickets left for next week previews in Newcastle but get them quick.'
          //   item.date = '20-10-2017'
          //   vm.smPosts.push(item)
          // }
        })
      }, 200)

      //  for (var i = 0; i < 3; i++) {
      // }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// Latest.vue?b9c6f0ae